import React from "react";

const DownloadDocumentIcon = ({ color, isHovered, hoveredColor }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <g clip-path="url(#clip0_7047_7110)">
          <path
            d="M9.61567 14.0548C9.84455 14.2838 10.2155 14.2837 10.4442 14.0548L12.9546 11.5444C13.1835 11.3157 13.1835 10.9446 12.9546 10.7159C12.7259 10.487 12.3549 10.487 12.126 10.7159L10.6159 12.226V7.99219C10.6159 7.66855 10.3534 7.40625 10.0299 7.40625C9.70631 7.40625 9.44401 7.66855 9.44401 7.99219V12.226L7.93385 10.7159C7.70496 10.487 7.33402 10.487 7.10514 10.7159C6.87641 10.9446 6.87641 11.3157 7.10514 11.5444L9.61567 14.0548Z"
            fill={isHovered ? hoveredColor : color}
          />
          <path
            d="M12.5404 15.5625H7.51953C7.19604 15.5625 6.93359 15.8248 6.93359 16.1484C6.93359 16.4719 7.19604 16.7344 7.51953 16.7344H12.5404C12.8639 16.7344 13.1264 16.4719 13.1264 16.1484C13.1264 15.8248 12.8641 15.5625 12.5404 15.5625Z"
            fill={isHovered ? hoveredColor : color}
          />
          <path
            d="M15.677 0.5H6.89056C6.73523 0.5 6.58615 0.561798 6.47629 0.671661L2.71072 4.43723C2.60086 4.54709 2.53906 4.69617 2.53906 4.8515V18.6589C2.53906 19.674 3.36502 20.5 4.38019 20.5H15.677C16.6893 20.5 17.5182 19.6815 17.5182 18.6589V2.34113C17.5182 1.32886 16.6998 0.5 15.677 0.5ZM6.93222 1.87283V4.22391C6.93222 4.59302 6.63208 4.89316 6.26297 4.89316H3.9119L6.93222 1.87283ZM16.3463 18.6589C16.3463 19.0234 16.0516 19.3281 15.677 19.3281H4.38019C4.01123 19.3281 3.71094 19.0278 3.71094 18.6589V6.06519H6.26297C7.27814 6.06519 8.1041 5.23923 8.1041 4.22406V1.67188H15.677C16.0417 1.67188 16.3463 1.96667 16.3463 2.34113V18.6589Z"
            fill={isHovered ? hoveredColor : color}
          />
        </g>
        <defs>
          <clipPath id="clip0_7047_7110">
            <rect
              width="20"
              height="20"
              fill={isHovered ? hoveredColor : color}
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default DownloadDocumentIcon;
